"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateChecklistContent = void 0;
var localization_1 = require("../../../components/localization");
var contentBlocks_1 = require("../../../utils/contentBlocks");
var template = "<div class=\"eg-content-editor\" data-type=\"checklistItem\">Checklist Item</div>";
var defaultChildContentBlocksCount = 3;
function getDefaultChildContentBlock(index) {
    return {
        text: template,
        position: index,
        childContentBlocks: [
            {
                text: "<div class=\"eg-content-editor\" data-type=\"textEditorWithoutHeading\" style=\"width: 100%;\">\n          <div class=\"column\" style=\"display: inline-block; width: 100%; vertical-align: top;\">\n          " + localization_1.localize('checklistItemText') + "\n          </div>\n          </div>",
                position: 0
            }
        ]
    };
}
var generateChecklistContent = function (children) {
    if (children === void 0) { children = defaultChildContentBlocksCount; }
    return ({
        position: 0,
        text: contentBlocks_1.defaultTemplate('checklistContent'),
        childContentBlocks: contentBlocks_1.getInitialContentBlocks(children, getDefaultChildContentBlock)
    });
};
exports.generateChecklistContent = generateChecklistContent;
